import React, { Component } from 'react';
import CategoryMenu from './CategoryMenu/CategoryMenu';
import CategoryItems from './CategoryItems/CategoryItems';

class FoodSelector extends Component {
    render() {
       // console.log('food selector ',this.props);
       let items = [];
       if (this.props.category == 'brewbar') {
           let subcats = new Set();
           this.props.categoryFood.forEach((a)=>subcats.add(a['subcategory'] ?? ''));
           let sorted = Array.from(subcats).sort()
           if (sorted.includes('Featured')) { // Move FEATURED to the start
               const f = sorted.splice(sorted.indexOf('Featured'), 1);
               if (f.length > 0)
                   sorted.unshift(f[0]);
           }
           if (sorted.includes('')) { // Move OTHER to the end
               const f = sorted.splice(sorted.indexOf(''), 1);
               if (f.length > 0)
                   sorted.push(f[0]);
           }
           if (sorted.length > 1) {
            sorted.forEach((a)=> {
                    const l = a.trim();
                    if (l == '') {
                        items.push(<h3 className="subcat" key={"heading-" + l}>Other</h3>);
                    } else {
                        items.push(<h3 className="subcat" key={"heading-" + l}>{l}</h3>);
                    }
                    items.push(<CategoryItems {...this.props } key={l} subcategory={l} subcategorize={true} />);
            });
           } else {
            items = [<CategoryItems {...this.props } key="nosubcats" subcategorize={false} />];
           }
       } else {
            items = [<CategoryItems {...this.props } key="nosubcats" subcategorize={false} />];
       }

        return (
            <div className="blockwrap food-selector">
                
                <CategoryMenu {...this.props}  />
                {items}
            </div>
        );
    }
}

export default FoodSelector;